import {Carousel} from "@mantine/carousel";
import {Box, Flex, Image, Text} from "@mantine/core";
import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';

const _CategoryDiscoverByArea = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                // bg={component?.customize_styles?.text_decoration?.background_color}
                fz={component?.customize_styles?.text_decoration?.font_size}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
            >
                {component?.customize_properties?.label}
            </Text>
            <Carousel
                loop
                slideSize="30%"
                slideGap="xs"
                align="start"
                withControls={false}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}

            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={item.id}>
                            <Flex
                                pos="relative"
                                align="center"
                                justify="center"
                                direction="row"
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                style={{
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,

                                }}
                            >
                                <Image
                                    width={component?.customize_styles?.image_decoration?.width}
                                    height={component?.customize_styles?.image_decoration?.height}
                                    fit="cover"
                                    src={item.image_url}
                                    fallbackSrc={CategoryPlaceholderImage}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    alt={item.name}
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                />
                                <Text
                                    pos="absolute"
                                    lineClamp={1}
                                    translate="yes"

                                    c={component?.customize_styles?.name_text_decoration?.color}
                                    fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                    fz={component?.customize_styles?.name_text_decoration?.font_size}
                                    fs={component?.customize_styles?.name_text_decoration?.font_style}

                                >
                                    {item.name}
                                </Text>
                            </Flex>
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    )
}
export default _CategoryDiscoverByArea;